import styled from 'styled-components';

import { StatusBanner as StatusBannerComponent } from '@xing-com/banner';
import { TextButton } from '@xing-com/button';
import {
  scale080,
  scale110,
  spaceXL,
  spaceXXS,
  xdlColorText,
} from '@xing-com/tokens';

export const StatusBanner = styled(StatusBannerComponent)`
  z-index: 399;

  p {
    color: ${xdlColorText};
    line-height: ${scale110};
    font-size: ${scale080};
  }
`;

export const BannerAction = styled(TextButton)`
  padding-left: ${spaceXXS};
  height: ${spaceXL};
`;
